export enum ECodigoFinalidadeArquivo {
    ArquivoOriginal = 0,
    ArquivoSubstituto = 1
}
